
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcIntegrationFleetButton as ObcIntegrationFleetButtonElement} from '@oicl/openbridge-webcomponents/dist/integration-systems/integration-fleet-button/integration-fleet-button.js';
 
 
 

 
 export const ObcIntegrationFleetButton = createComponent({
   react: React,
   tagName: 'obc-integration-fleet-button',
   elementClass: ObcIntegrationFleetButtonElement,
   events: {
     
   }
  });
 
 